export const EmployeeDashboardMobileSidePanelStyles = {
    viewContainer: {
        padding: '15px 20px',
        backgroundColor: '#FAFAFA',
    },
    privateOfferViewContainer: {
        padding: '15px 20px',
        backgroundColor: '#FAFAFA',
    },
    appbar: {
        backgroundColor: '#FFF',
        width: '100%',
        overflow: 'hidden',
        color: '#333'
    },
    notificationBell: {
        color: '#333'
    },
    shiftDetail: {
        backgroundColor: '#FAFAFA',
    },
    shiftInfo: {
        backgroundColor: '#FFF',
        padding: '10px 15px'
    },
    ownerSection: {
        backgroundColor: '#FFF',
        padding: '10px 15px'
    },
    managerSettingButton: {
        border: '1px solid #EEEEEE',
        borderRadius: 5,
        backgroundColor: '#FFF',
        marginBottom: 5
    },
    managerSettingButtonText: {
        width: '90%',
        textAlign: 'left',
        color: '#0A54A2'
    },
    managerSettingButtonArrow: {
        width: '10%'
    },
    segments: {
        padding: '10px 15px'
    },
    bottomBar: {
        backgroundColor: '#FFF',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        left: 0,
        border: '1px solid #efefef',
        boxShadow: '0px 0px 10px -10px rgba(0,0,0,0.75)',
        minHeight: 48,
    },
    privateEmployeeWarningModal: {
        borderRadius: '30px 30px 0px 0px',
        padding: '20px'
    },
    vtoSidePanelSection: {
        backgroundColor: '#FFFFFF',
        padding: 15,
        overflow: 'hidden',
        width: '100%',
    },
    primaryButton: {
        backgroundColor: '#0A54A2',
        color: '#FFFFFF',
        fontSize: 14,
        '&:disabled': {
            backgroundColor: '#3B76B4',
            color: '#EFEFEF',
        }
    },
    secondaryButton: {
        backgroundColor: '#FFFFFF',
        color: '#333333',
        fontSize: 14,
        border: '1px solid #DCDCDC'
    },
    formButton: {
        justifyContent: 'start',
        border: '1px solid #efefef',
        marginBottom: 5,
        backgroundColor: '#FFFFFF',
        color: '#333333'
    },
    formButtonWithHover: {
        justifyContent: 'start',
        border: '1px solid #efefef',
        marginBottom: 5,
        backgroundColor: 'transparent',
        color: '#333333',
        '&:hover': {
            backgroundColor: '#FFFFFF'
        }
    },
    viewHeader: {
        fontWeight: 700,
        marginBottom: 5
    },
    subHeader: {
        fontSize: 16,
        fontWeight: 700,
        marginBottom: 5,
        color: '#3A3A3A',
    },
    shiftCard: {
        backgroundColor: '#FFF',
        border: '1px solid #D7D7D7',
        borderLeft: '4px solid #0A54A2',
        borderRadius: 5,
        padding: '5px 10px',
    },
    shiftInfoHeaderEmployeeNameWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    historyItemContainer: {
        margin: '12px 0',
    },
    historyLogFirst: {
        fontSize: '14px'
    },
    historyLogName: {
        fontWeight: 'bold',
        wordWrap: 'break-word',
    },
    historyLogshiftTime: {
        textDecoration: 'underline'
    },
    historyLogDate: {
        fontSize: '12px',
        color: '#878787'
    },
    contentWrapper: {
        height: 'calc(100vh - 102px)',
        backgroundColor: '#FAFAFA',
        overflow: 'auto',
    },
    selectWrapper: {
        marginBottom: 0,
    },
    preferredDayPickerContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    preferredDateNoPadding: {
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    recipientNameStyle: {
        fontSize: '14px',
        fontFamily: 'Roboto',
        fontWeight: '400',
        lineHeight: '1.43',
        letterSpacing: '0.01071em'
    },
};


export const EmployeeDashboardMobileStyles = (theme) => {
    return {
        drawerFullHeight: {
            height: 'calc(100%)',
        },
        closeButton: {
            color: "#DEDEDE",
            margin: 5
        },
        monthSelectorBar: {
            fontSize: "17px",
            overflow: "hidden",
        },
        fullPage: {
            margin: 'auto',
            backgroundColor: '#FFFFFF'
        },
        horizontalCentered: {
            margin: 'auto',
        },
        calendarHeader: {
            backgroundColor: "#FAFAFA",
            textAlign: "center"
        },
        calendarRow: {
            backgroundColor: "#FAFAFA",
            textAlign: "center",
            height: "88px"
        },
        calendarHeaderField: {
            display: "inline-block",
            width: "14%",
            borderRight: "1px solid #FAFAFA",
            borderLeft: "1px solid #FAFAFA",
            textAlign: "center",
            paddingTop: "6px",
            paddingBottom: "6px",
            fontSize: "12px",
            fontWeight: "bold"
        },
        emptyCalendarDayCell: {
            display: "inline-block",
            width: "14%",
            backgroundColor: "#FAFAFA",
            border: "1px solid #E7E7E7",
            height: "88px",
            verticalAlign: "top",
        },
        calendarDayCell: {
            display: "inline-block",
            width: "14%",
            backgroundColor: "#FFFFFF",
            border: "1px solid #E7E7E7",
            height: "88px",
            verticalAlign: "top",
        },
        calendarDayCellOtherMonth: {
            backgroundColor: "#FAFAFA",
            border: "1px solid #E7E7E7",
            opacity: 0.4,
        },
        calendarDayCellDate: {
            fontWeight: "bold",
            fontSize: "14px",
            textAlign: "center"
        },
        calendarDayCellDots: {
            textAlign: "center",
            height: "10px",
            lineHeight: "8px"
        },
        calendarDayCellBoxes: {
            textAlign: "center",
            paddingBottom: "2px",
            fontSize: "0px",
        },
        shiftsDot: {
            display: "inline-block",
            width: "4px",
            height: "4px",
            backgroundColor: "#0A54A2",
            borderRadius: "2px",
            margin: "0px 3px"
        },
        paycodesDot: {
            display: "inline-block",
            width: "4px",
            height: "4px",
            backgroundColor: "#48D960",
            borderRadius: "2px",
            margin: "0px 3px"
        },
        dayCellLongBox: {
            display: "inline-block",
            width: "90%",
            margin: "1px",
            fontSize: "10px",
            fontWeight: "bold",
        },
        dayCellSmallBox: {
            display: "inline-block",
            width: "45%",
            margin: "1px",
            marginTop: "0px",
            fontSize: "10px",
            fontWeight: "bold",
        },
        dayCellBox_MINE: {
            backgroundColor: "#8A21E629",
            border: "1px solid #8A21E6"
        },
        dayCellBox_TC: {
            backgroundColor: "#ffdd0029",
            border: "1px solid #ffdd00"
        },
        dayCellBox_SS: {
            backgroundColor: "#FF7A5929",
            border: "1px solid #FF7A59"
        },
        dayCellBox_OS: {
            backgroundColor: "#EE0F0F29",
            border: "1px solid darkred"
        },
        dayCellBox_VTO: {
            backgroundColor: "#5eb25e",
            border: "1px solid #006600"
        },
        monthListContent: {
            padding: "0px 10px"
        },
        monthListYear: {
            marginTop: "15px",
            color: "#3A3A3A",
            fontSize: "20px",
            height: "30px"
        },
        monthListMonth: {
            color: "#3A3A3A",
            fontSize: "14px",
            height: "40px",
            lineHeight: "40px",
            borderBottom: "2px solid #EEEEEE",
        },
        dailyManagerSettingGroupPanel: {
            backgroundColor: "rgb(250, 250, 250)",
            padding: "5px"
        },
        dailyManagerSettingPanel: {
            backgroundColor: "white",
            marginBottom: "5px",
            border: "1px solid #EEEEEE",
            borderRadius: "4px",
        },
        dailyManagerSettingHeader: {
            position: "relative",
            height: "34px",
            padding: "5px",
            fontSize: "12px",
            fontWeight: "bold",
        },
        dailyManagerSettingCollapse: {
            display: "inline-block",
            margin: "0 5px",
            fontSize: "20px",
            verticalAlign: "top",
            '& svg': {
                verticalAlign: "top",
            }
        },
        dailyManagerSettingName: {
            display: "inline-block",
            verticalAlign: "top",
            paddingTop: "3px",
        },
        dailyManagerSettingAmountBox: {
            position: "absolute",
            top: "5px",
            right: "10px",
            width: "24px",
            height: "24px",
            textAlign: "center",
            paddingTop: "2px",
            lineHeight: "21px"
        },
        amountBoxMyRequests: {
            backgroundColor: "#8A21E629",
            color: "#8A21E6",
        },
        amountBoxShifts: {
            backgroundColor: "#0A54A229",
            color: "#0A54A2",
        },
        amountBoxPaycodes: {
            right: "39px",
            backgroundColor: "#48D96029",
            color: "#48D960",
        },
        amountBoxTC: {
            backgroundColor: "#ffdd0029",
            color: "#e6c700",
        },
        amountBoxSS: {
            backgroundColor: "#FF7A5929",
            color: "#FF7A59"
        },
        amountBoxOS: {
            backgroundColor: "#EE0F0F29",
            color: "darkred"
        },
        amountBoxVTO: {
            backgroundColor: "#5eb25e29",
            color: "#006600"
        },
        dailyManagerSettingShift: {
            padding: "5px",
        },
        shiftCard: {
            backgroundColor: '#FFF',
            border: '1px solid #D7D7D7',
            borderLeft: '4px solid #0A54A2',
            borderRadius: 5,
            padding: '5px 10px',
            marginBottom: '5px',
            '&:last-child': {
                marginBottom: '0px'
            }
        },
        shiftCardTypeWrapper: {
            width: 'calc(100% - 115px)',
            display: 'inline-block',
        },
        shiftCardType: {
            display: "inline-block",
            fontSize: "13px",
            padding: "1px 5px",
            fontWeight: "bold"
        },
        statusLabel: {
            width: 115,
            display: 'inline-block',
            textAlign: 'right'
        },
        topBar: {
            borderBottom: "1px solid #EEEEEE",
        },
        topBarAppName: {
            fontSize: "16px",
            // textTransform: "uppercase",
            textAlign: "center",
            lineHeight: "13px"
        },
        buttonTopBar: {
            height: "34px",
        },
        topBarExit: {
            textAlign: "right"
        },
        topBarMenu: {
            padding: "0px 8px",
            width: "300px"
        },
        topBarMenuItem: {
            fontSize: "16px",
            fontWeight: "400",
            padding: "4px 0px",
            margin: "4px 0px",
            '& svg': {
                margin: '0 10px'
            }
        },
        topBarNameSection: {
            fontSize: "20px",
            fontWeight: "500",
            padding: "5px 8px",
        },
        filterTitle: {
            fontSize: "16px",
            fontWeight: "400",
            padding: "4px 0px",
            margin: "4px 0px",
        },
        filterItem: {
            fontSize: "16px",
            fontWeight: "400",
            padding: "2px 0px",
            margin: "2px 0px",
            marginLeft: "8px",
            '& label span': {
                paddingLeft: '6px'
            }
        },
        listViewItem: {
            borderBottom: "1px solid #EEEEEE",
            '&:first-child': {
                borderTop: '1px solid #EEEEEE'
            }
        },
        listViewDayOfTheWeek: {
            width: "100%",
            display: "block",
            paddingLeft: "14px",
            fontSize: "13px",
            color: "#888888"
        },
        listViewDate: {
            display: "block",
            color: "black",
            fontSize: "22px",
            fontWeight: "500",
            paddingLeft: "14px",
        },
        listViewBoxesArea: {
            verticalAlign: "center",
            flexDirection: "row-reverse",
            display: 'flex'
        },
        listViewManagerSettingAmountBox: {
            marginTop: "14px",
            marginRight: "10px",
            width: "24px",
            height: "24px",
            textAlign: "center",
            paddingTop: "2px",
            lineHeight: "21px"
        },
        historyItemContainer: {
            margin: '12px 16px',
            minWidth: 280
        },
        historyLogFirst: {
            fontSize: '14px'
        },
        historyLogName: {
            fontWeight: 'bold'
        },
        historyLogshiftTime: {
            textDecoration: 'underline'
        },
        historyLogDate: {
            fontSize: '12px',
            color: '#878787'
        },
        notificationsExit: {
            margin: "16px 1px",
            display: 'flex',
            position: 'relative',
        },
        notificationsExitButton: {
            justifyContent: 'flex-start',
            alignSelf: 'flex-start',
            position: 'absolute',

        },
        NotificationsTitle: {
            fontSize: "16px",
            fontWeight: "500",
            width: '100%',
            display: 'inline-block',
            textAlign: 'center',
        },
        drawerPaper: {
            width: '100%'
        },
        chipTC: {
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: '#ffdd0029',
            color: '#6c757d',
            textShadow: '1px 1px #DADADA'
        },
        chipSS: {
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: '#FF7A5929',
            color: '#FF7A59',
        },
        chipOS: {
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: '#EE0F0F29',
            color: '#EE0F0F',
        },
        chipVTO: {
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '0px',
            backgroundColor: '#c4ecc4',
            color: '#006600',
        },
        badgeColor: {
            backgroundColor: '#F46F6F',
            color: '#FFFFFF',
            fontSize: '10px',
        },
        buttonEllipsis: {
            justifyContent: "flex-end",
            minWidth: '25px',
        },
        bellIcon: {
            width: '0.70em'
        },
        badgeSize: {
            fontSize: '0.85em',
            right: -7,
            top: 7,
        },
        signUpIconSize:{
            height: '0.75em'
        }
    }
}
